export default (props, vars) =>
  `app-step-row-${vars?.['defaultbox145']?.['index']}`;
